import React from "react";
import PropTypes from "prop-types";
import styles from "./style/ManageType.module.css";
import clsx from "clsx";
import { getDiscountValid } from "@helpers";
import { Button, ButtonGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const ManageType = ({ data }) => {
  // state

  // variables
  const {
    id,
    title,
    category,
    createdAt,
    price,
    thumbnailUrl,
    user,
    isSave = false,
    percentCompletion,
    avgRate,
    totalTime,
    isEnroll,
    isPurchased,
    isFree,
    myRating,
    discounts,
  } = data;
  // logics before hooks

  // hooks

  // logics
  const navigate = useNavigate();

  // UI partials
  const wasCreatedSince = moment(createdAt).add(7, "hours").fromNow();

  // effects
  const handleClickEdit = () => {
    navigate(`/update-course/${id}`);
  };

  const handleClickPromote = () => {
    navigate("/instructor-courses");
  };
  // render
  return (
    <div className="manageType d-flex gap-2 flex-wrap">
      <div className="d-flex justify-content-between align-items-center w-100">
        <span className={clsx(styles.fs12)}>{wasCreatedSince}</span>
        <div className="price">
          {/* <span className="fs-6 fw-bold">{price}$</span> */}
          <span className="fs-6 fw-bold">
            {getDiscountValid(discounts) !== 0 ? (
              <div className={clsx(styles.discountAppear)}>
                <span>
                  {`$${(price * (1 - getDiscountValid(discounts))).toFixed(2)}`}
                </span>
                <span className={clsx(styles.oldPrice)}>{price}</span>
              </div>
            ) : (
              <span> {`$${price}`}</span>
            )}
            {/* $ */}
          </span>
          {/* <span className="fs-6 ml-2">
            <del>12$</del>
          </span> */}
        </div>
      </div>
      <ButtonGroup className="w-100 mt-2">
        <Button size="sm" variant="primary" onClick={handleClickPromote}>
          Discount <i className="bi bi-megaphone"></i>
        </Button>
        <Button size="sm" variant="outline-primary" onClick={handleClickEdit}>
          Edit <i className="bi bi-pencil-square"></i>
        </Button>
      </ButtonGroup>
    </div>
  );
};

/* required: display name */
ManageType.displayName = "ManageType";

/* required: props types */
ManageType.propTypes = {};

/* required: default props */
ManageType.defaultProps = {};

export { ManageType };
